export default __webpack_public_path__ + "static/yas-563eba60dbe3acd023fb1edbeed3973c.png";